import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faNewspaper } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { NgMarqueeModule } from 'ng-marquee';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MissedAppointmentsWidgetComponent } from './missed-appointments-widget/missed-appointments-widget.component';
import { NewsWidgetComponent } from './news-widget/news-widget.component';
import { OneNumberComponent } from './one-number/one-number.component';
import { RecallsWidgetComponent } from './recalls-widget/recalls-widget.component';
import { SupportWidgetComponent } from './support-widget/support-widget.component';

@NgModule({
    declarations: [
      NewsWidgetComponent,
      RecallsWidgetComponent,
      OneNumberComponent,
      MissedAppointmentsWidgetComponent,
      SupportWidgetComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        NgMarqueeModule,
        TooltipModule,
        TranslateModule,
        RouterModule.forChild([
        {path: '', component: SupportWidgetComponent}
      ])
    ]

})
export class DashboardModule {
    constructor() {
        // Add an icon to the library for convenient access in other components
        fontAwesomeLibrary.add(faCoffee);
        fontAwesomeLibrary.add(faNewspaper);
    }
}
